import { createGlobalStyle } from 'styled-components';

// 색상 팔레트
export const colors = {
  secondary: {
    main: '#1976d2',
    light: '#42a5f5',
    dark: '#1565c0',
    contrastText: '#ffffff'
  },
  primary: {
    main: '#1d2340',
    light: '#d9412b',
    dark: '#2c3561',
    contrastText: '#ffffff'
  },
  success: {
    main: '#1d2340',
    light: '#d9412b',
    dark: '#2c3561',
    contrastText: '#ffffff'
  },
  error: {
    main: '#d32f2f',
    light: '#ef5350',
    dark: '#c62828',
    contrastText: '#ffffff'
  },
  warning: {
    main: '#ed6c02',
    light: '#ff9800',
    dark: '#e65100',
    contrastText: '#ffffff'
  },
  info: {
    main: '#0288d1',
    light: '#03a9f4',
    dark: '#01579b',
    contrastText: '#ffffff'
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121'
  },
  text: {
    primary: 'rgba(0, 0, 0, 0.87)',
    secondary: 'rgba(0, 0, 0, 0.6)',
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  background: {
    default: '#ffffff',
    paper: '#ffffff'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  gradients: {
    primary: '#1d2340',
    secondary: 'linear-gradient(135deg, #d9412b 0%, #1d2340 100%)',
    success: 'linear-gradient(135deg, #d9412b 0%, #1d2340 100%)',
    warning: 'linear-gradient(135deg, #ff4d4d 0%, #ff9966 100%)',
    error: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    info: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    dark: '#1d2340',
    light: 'linear-gradient(135deg, #d9412b 0%, #1d2340 100%)',
    sunset: '#1d2340',
    ocean: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    forest: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    fire: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    soft: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)',
    modern: '#1d2340',
    elegant: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
    vibrant: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
    calm: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
    warm: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
    cool: 'linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)'
  }
};

// 애니메이션
export const animations = {
  fadeInUp: `
    @keyframes fadeInUp {
      0% {
        transform: translate3d(0, 100%, 0);
      }
      to {
        transform: translateY(0);
      }
    }
  `,
  fadeInScale: `
    @keyframes fadeInScale {
      0% {
        opacity: 0;
        transform: scale(0.5);
      }
      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  `,
  slideLeftIn: `
    @keyframes slideLeftIn {
      from {
        opacity: 0;
        transform: translateX(-100%);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  `,
  slideIn: `
    @keyframes slideIn {
      from {
        opacity: 0;
        transform: translateX(100%);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }
  `,
  slideUp: `
    @keyframes slideUp {
      0% {
        opacity: 0;
        transform: translateY(100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `,
  slideDown: `
    @keyframes slideDown {
      0% {
        opacity: 0;
        transform: translateY(-100%);
      }
      100% {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `
};

// 타이포그래피
export const typography = {
  fontFamily: '"Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", sans-serif',
  fontSize: 15,
  fontWeightLight: 400,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontSize: '2.25rem',
    fontWeight: 700,
    lineHeight: 1.32,
    letterSpacing: '-0.03em'
  },
  h2: {
    fontSize: '1.875rem',
    fontWeight: 700,
    lineHeight: 1.35,
    letterSpacing: '-0.028em'
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.4,
    letterSpacing: '-0.024em'
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.02em'
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.45,
    letterSpacing: '-0.02em'
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 600,
    lineHeight: 1.5,
    letterSpacing: '-0.018em'
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.7,
    letterSpacing: '-0.02em'
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.65,
    letterSpacing: '-0.018em'
  },
  button: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.02em',
    textTransform: 'none'
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.55,
    letterSpacing: '-0.01em'
  },
  overline: {
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
    textTransform: 'none'
  }
};

// 간격 (spacing)
export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  xxl: '3rem'
};

// 그림자
export const shadows = {
  none: 'none',
  xs: '0px 2px 1px -1px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 1px 3px 0px rgba(0,0,0,0.12)',
  sm: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
  md: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
  lg: '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
  xl: '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
  main: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);'
};

// 테마 객체
export const lightTheme = {
  colors,
  animations,
  typography,
  spacing,
  shadows,
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%'
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
    },
    duration: {
      shortest: 150,
      shorter: 200,
      short: 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
  },
  breakpoints: {
    xs: '0px',
    sm: '600px',
    md: '900px',
    lg: '1200px',
    xl: '1536px'
  }
};

export const darkTheme = {
  ...lightTheme,
  colors: {
    ...colors,
    text: {
      primary: 'rgba(255, 255, 255, 0.87)',
      secondary: 'rgba(255, 255, 255, 0.6)',
      disabled: 'rgba(255, 255, 255, 0.38)'
    },
    background: {
      default: '#121212',
      paper: '#1e1e1e'
    },
    divider: 'rgba(255, 255, 255, 0.12)'
  }
};

// 글로벌 스타일
export const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  html {
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0;
    padding: 0;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: ${props => props.theme.typography.fontSize}px;
    line-height: 1.5;
    color: ${props => props.theme.colors.text.primary};
    background-color: ${props => props.theme.colors.background.default};
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: ${props => props.theme.typography.fontWeightRegular};
  }

  p {
    margin: 0;
  }

  a {
    color: ${props => props.theme.colors.primary.main};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }

  button {
    font-family: inherit;
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
  }

  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
  }

  ul, ol {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* 스크롤바 스타일링 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.grey[100]};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.grey[400]};
    border-radius: 4px;
    
    &:hover {
      background: ${props => props.theme.colors.grey[500]};
    }
  }

  /* 포커스 스타일 */
  *:focus {
    outline: 2px solid ${props => props.theme.colors.primary.main};
    outline-offset: 2px;
  }

  /* 선택 텍스트 스타일 */
  ::selection {
    background-color: ${props => props.theme.colors.primary.light};
    color: ${props => props.theme.colors.primary.contrastText};
  }

  /* 애니메이션 keyframes */
  ${props => props.theme.animations.fadeInUp}
  ${props => props.theme.animations.fadeInScale}
  ${props => props.theme.animations.slideLeftIn}
  ${props => props.theme.animations.slideIn}
  ${props => props.theme.animations.slideUp}
  ${props => props.theme.animations.slideDown}
`;
